namespace $.$$ {
	
	$mol_style_define( $giper_baza_unit_sand_dump, {
		
		Other: {
			padding: $mol_gap.text,
		},
		
	} )
	
}
